// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Date d\'achèvement réelle : ',
    actualCompletionDateFull: 'Date d\'achèvement réelle',
    AutoAssign_Issue: 'Assigner automatiquement les nouveaux problèmes à :',
    AutoAssign_Note: 'Le membre choisi sera assigné chaque fois qu\'une activité sera ajoutée au projet',
    AutoAssign_Request: 'Assigner automatiquement les nouvelles requêtes à :',
    AutoAssign_Task: 'Assigner automatiquement les nouvelles tâches à :',
    AutoAssign_Title: 'Assignation automatique',
    BaselineCaptureLabel: 'Saisir la référence',
    BaselineOverwrite: 'Remplacer la référence actuelle ?',
    BaselineOverwriteDescription: 'Vous avez déjà une référence pour ce projet. Si vous continuez, la référence actuelle sera perdue.',
    BaselineRecaptureLabel: 'Remplacer la référence',
    BaselineSuccess: 'La référence a été saisie avec succès.',
    Billed: 'Total facturé',
    Billing: 'Facturation',
    BillingSettingsTitle: 'Paramètres de facturation',
    BillingTypeNotBillable: 'Non facturable',
    BillingTypeProjectBillingSettings: 'Paramètres de facturation du projet',
    btnNotifications: 'Notifications',
    BudgetLeft: ' restant',
    BudgetTotal: ' total',
    By: 'par ',
    Change: 'modifier',
    Close: 'Fermer',
    ConfirmStatusDialogTitle: 'Terminer « {0} » ?',
    DayPluralFormat: '1#{0} jour#{0} jours',
    Days: '({0}j)',
    DeleteActivity: 'Supprimer l\'activité',
    DeleteProject: 'Supprimer le projet',
    Dependencies_Count: '1#{0} Dépendance#{0} Dépendances',
    DifferPermissionsMessage: 'indique que les autorisations du membre actuel du projet diffèrent des autorisations de rôle par défaut',
    DueIn_Ok: 'dû dans {0}',
    DueIn_Trouble: '{0} en retard',
    DueIn_Warning: 'dû aujourd\'hui',
    EditRoleAndPermissions: 'Modifier le rôle et les autorisations',
    endDate: 'Date de fin prévue : ',
    endDateFull: 'Date de fin prévue ',
    endLessThenStartMsg: 'La « date de fin » ne peut pas précéder la « date de début »',
    estimatedHours: '1# heure estimée# heures estimées',
    ExportToMsProject: 'Exporter vers MS Project',
    Fields: '1#{0} champ#{0} champs',
    FillCustomFields: '{0} doit encore être renseigné',
    Follow: 'Suivre',
    HideCustomFields: 'Masquer les champs personnalisés',
    hoursLeft: '1# heure restante# heures restantes',
    HoursOf: 'h sur ',
    HtmlField_ReadAll: '... tout lire',
    ImDoneText: 'J\'ai terminé ',
    IsMilestone: 'C\'est une étape importante',
    issue: 'Problème',
    MarkAsMilestone: 'Marquer comme étape',
    MemberPermission_Add: 'Ajouter',
    MemberPermission_Add_For_Someone_Else: 'Ajouter pour quelqu\'un d\'autre',
    MemberPermission_Add_Own: 'Ajouter pour soi',
    MemberPermission_CanEditActualExpenses: 'Modifier les dépenses réelles',
    MemberPermission_CanEditPlannedExpenses: 'Modifier les dépenses prévues',
    MemberPermission_CanLogExpenses: 'Enregistrer les dépenses',
    MemberPermission_CanManageProjectMembers: 'Gérer les membres',
    MemberPermission_CanViewMembersAndAssignees: 'Visualiser',
    MemberPermission_Delete: 'Supprimer',
    MemberPermission_Delete_All: 'Supprimer tout',
    MemberPermission_Edit: 'Modifier',
    MemberPermission_Edit_All: 'Modifier tout',
    MemberPermission_Edit_Assigned: 'Modifier les personnes assignées',
    MemberPermission_Manage_Assigned: 'Gérer les personnes assignées',
    MemberPermission_View_All: 'Tout visualiser',
    MemberPermission_View_and_Manage: 'Visualiser et gérer',
    MemberPermission_View_Assigned: 'Visualiser les personnes assignées',
    MemberPermissions_ExpensesTitle: 'Dépenses :',
    MemberPermissions_MembersAndAssigneesTitle: 'Membres et personnes assignées :',
    MemberPermissions_TasksTitle: 'Activités :',
    MemberPermissions_ThisProjectTitle: 'Projet :',
    MemberPermissions_TimeEntriesTitle: 'Saisies de temps :',
    Members: '1#{0} Membre#{0} Membres',
    no_assignee: 'Aucune personne assignée',
    On: ' le ',
    OwnBudget: 'Budget pour cette activité :',
    PercentDone: '1#% terminé#% terminés',
    PermissionsSettingsTitle: 'Autorisations de {0}',
    project: 'Projet',
    Project_NotFound_Message: 'Le projet demandé est introuvable ou vous n\'avez pas l\'autorisation d\'y accéder. Consultez votre administrateur {brandName} pour connaître les causes possibles. La clé d\'objet est {0}.',
    Project_NotFound_Title: 'Projet demandé introuvable',
    Project_WasCompleted_Ok: 'Le projet a été achevé <b>{0} avant</b> sa date de fin prévue',
    Project_WasCompleted_Trouble: 'Le projet a été achevé <b>{0} après</b> sa date de fin prévue',
    Project_WasCompleted_Warning: 'Le projet a été achevé à la date de fin prévue',
    RatioOfMoneySpent: '1#{0} sur {1} dépensé#{0} sur {1} dépensés',
    RepeatActivity: 'Répéter',
    request: 'Requête',
    ResumeWorkHelpText: 'Vous avez terminé votre affectation. ',
    ResumeWorkText: 'Reprendre le travail',
    RoleTitle: 'Rôle pour ce projet',
    Save: 'Enregistrer',
    Set_actualCompletionDate: 'Définir la date d\'achèvement réelle',
    Set_budget: 'Définir le budget',
    Set_categoryId: 'Définir la catégorie',
    Set_customerId: 'Définir le client',
    Set_dates: 'Définir les dates ou la durée',
    Set_description: 'Ajouter une description',
    Set_endDate: 'Définir la date de fin prévue',
    Set_estimatedHours: 'Définir les heures estimées',
    Set_hoursLeft: 'Définir les heures restantes',
    Set_labor_budget: 'Définir le budget de la main-d\'œuvre',
    Set_portfolioId: 'Définir le portefeuille',
    Set_short_hoursLeft: 'Définir les heures restantes',
    SetAsRootLevel: 'Définir comme activité de niveau supérieur',
    SetCompleted: 'Définir comme terminé',
    short_hoursLeft: '1# heure restante# heures restantes',
    ShowCustomFields: 'Afficher les champs personnalisés',
    Spent: '1#h passée#h passées',
    Status: 'Statut : ',
    task: 'Tâche',
    Task_NotFound_Message: 'L\'activité demandée est introuvable ou vous n\'avez pas l\'autorisation d\'y accéder. Consultez votre administrateur {brandName} pour connaître les causes possibles. La clé d\'objet est {0}.',
    Task_NotFound_Title: 'Activité demandée introuvable',
    Task_WasCompleted_Ok: 'L\'activité a été achevée <b>{0} avant</b> sa date de fin prévue',
    Task_WasCompleted_Trouble: 'L\'activité a été achevée  <b>{0} après</b> sa date de fin prévue',
    Task_WasCompleted_Warning: 'L\'activité a été achevée à la date de fin prévue',
    today: 'Aujourd\'hui',
    UnFollow: 'Ne plus suivre',
    WindowUnload_UnsavedChanges: ' Il y a des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?',
};
